function headerInit() {
    const navigation = $('#header .header-bottom .navigation-wrapper').clone();
    const siteName = $('#header .header-top .header-top-wrapper .site-name')

    siteName.after(navigation);
}

